import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-layout-spinner',
  templateUrl: './main-layout-spinner.component.html',
  styleUrls: ['./main-layout-spinner.component.scss']
})
export class MainLayoutSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
